import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import { COLORS, SIZES, WEIGHT } from "theme";
//import GoogleMap from "./components/GoolgeMap";
import { useSelector } from "react-redux";
import H2 from "ReusableComponents/Text/H2";
import H3 from "ReusableComponents/Text/H3";
import { GM } from "./components/GM";
import LocationBox from "./components/LocationBox";
import "./style.css";

const ChargingLocation = ({ small, medium }) => {
  const { states, cities } = useSelector((state) => state.Landing);

  const [state, setState] = useState({
    city_name: "New Delhi",
    state_name: "Delhi",
  });

  const [cityOptions, setCityOptions] = useState([]);

  const [chargingHubs, setChargingHubs] = useState([]);

  useEffect(() => {
    if (state.state_name) {
      const filterCities = cities.filter(
        (item) =>
          state.state_name ===
          item?.attributes?.linked_state?.data?.attributes?.state_name
      );

      setCityOptions(filterCities);

      const hubs = states.find(
        (item) => item.attributes?.state_name === state.state_name
      );
      setChargingHubs(hubs?.attributes?.charging_network_hubs?.data);
    }
    if (state.state_name && state.city_name) {
      const filterCities = cities.filter(
        (item) =>
          state.state_name ===
          item?.attributes?.linked_state?.data?.attributes?.state_name
      );

      setChargingHubs(filterCities[0]?.attributes?.charging_network_hubs?.data);
    }
  }, [state.state_name, state.city_name]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value === "None") return;
    if (name === "state_name") {
      setState({ ...state, [name]: value, city_name: "" });
    } else setState({ ...state, [name]: value });
  };
  return (
    <Grid container spacing={2} id="chargingnetwork">
      <Grid item xs={12} md={6} lg={4} style={{ padding: 32, paddingLeft: 54 }}>
        <Box display="flex" flexDirection="column">
          <Box>
            <H2
              textColor={COLORS.white}
              fontSize="24px"
              fontWwight={WEIGHT.bold}
            >
              Charging Station Locator
            </H2>
          </Box>
          <Box marginTop={SIZES.twentyFour} marginBottom={SIZES.sizteen}>
            <Box position="relative">
              <select
                value={state.state_name}
                name="state_name"
                onChange={handleChange}
                style={{
                  padding: "12px 24px",
                  width: "100%",
                  background: "none",
                  color: "white",
                }}
              >
                <option value="None" selected>
                  Select State
                </option>

                {states &&
                  states.map((item) => (
                    <option value={item?.attributes?.state_name} key={item?.id}>
                      {item?.attributes?.state_name}
                    </option>
                  ))}
              </select>
              <i
                className="arrow down"
                style={{
                  position: "absolute",
                  top: "15px",
                  right: SIZES.twentyFour,
                }}
              ></i>
            </Box>
          </Box>
          <Box position="relative">
            <select
              value={state.city_name}
              name="city_name"
              onChange={handleChange}
              style={{
                padding: "12px 24px",
                width: "100%",
                background: "none",
                color: "white",
              }}
            >
              <option value="None" selected>
                Select City
              </option>
              {state.state_name && (
                <>
                  {cityOptions.map((item) => (
                    <option key={item.id} value={item?.attributes?.city_name}>
                      {item?.attributes?.city_name}
                    </option>
                  ))}
                </>
              )}
            </select>

            <i
              className="arrow down"
              style={{
                position: "absolute",
                top: "15px",
                right: SIZES.twentyFour,
              }}
            ></i>
          </Box>
          <Box marginTop="44px" marginBottom="10px" id="locations">
            <H3
              textColor={COLORS.white}
              fontSize="18px"
              fontWwight={WEIGHT.regular}
              margin={SIZES.zero}
            >
              Result For Charging Stations:
            </H3>
          </Box>
          <Box maxH="340px" minH="300px" overflowY="scroll" id="locations">
            {chargingHubs &&
              chargingHubs.map((item) => (
                <Box margin="8px 0">
                  <LocationBox
                    id={item?.id}
                    name={item?.attributes?.evongo_hubs}
                    place={item?.attributes?.hub_address}
                    lat={item?.attributes?.latitude}
                    long={item?.attributes?.longitude}
                  />
                </Box>
              ))}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6} lg={8} style={{ padding: "16px 0 0 0" }}>
        <GM
          isMarkdownShown
          chargingHubs={chargingHubs}
          small={small}
          mapElement={<div style={{ height: small ? "11%" : `100vh` }} />}
        />
      </Grid>
    </Grid>
  );
};

export default ChargingLocation;
